import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { BasicBooking } from '../../../../common/graphql/fragments/gql/BasicBooking';
import { useUpdateSubmit } from '../../../../common/update-information/hooks/useUpdateSubmit';
import { EnsLink } from '../../../../common-ui/import-export/EnsLink';
import { openEnsAfterSave } from '../../../../services/update-form/updateFormActions';
import { getFormIsEdited } from '../../../../services/update-form/updateFormReducer';
import { useAppDispatch } from '../../../../store/appDispatch';
import type { StoreState } from '../../../../store/storeState';

interface BookingUpdateEnsButtonProps {
  booking: BasicBooking;
  optional: boolean;
}

export function BookingUpdateEnsLink({ booking, optional }: BookingUpdateEnsButtonProps) {
  const dispatch = useAppDispatch();

  const mapState = useCallback(
    (state: StoreState) => {
      return getFormIsEdited(state, {
        bookingNo: booking.bookingNo,
        formId: 'Details',
      });
    },
    [booking.bookingNo],
  );

  const edited = useSelector(mapState);

  const { submitting } = useUpdateSubmit({
    bookingNo: booking.bookingNo,
    formId: 'Details',
  });

  return (
    <EnsLink
      disabled={submitting}
      confirmed={booking.importReference.ensConfirmed}
      ensUrl={booking.ensUrl}
      trackerCategory={'Details'}
      optional={optional}
      onClick={
        edited
          ? () =>
              dispatch(
                openEnsAfterSave({
                  bookingNo: booking.bookingNo,
                  formId: 'Details',
                }),
              )
          : undefined
      }
    />
  );
}
